import React from "react";
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Checkbox from '@mui/material/Checkbox'
import { useAppContext } from "../../context";
import text from "../../Text/text.json"


export default function ConsentDialog() {

    // Define the type for createOrder to include isCheck
    type CreateOrderType = {
        isCheck: boolean;
        // add other properties of createOrder here if needed
        [key: string]: any;
    };

    const { createOrder, setCreateOrder } = useAppContext() as {
        createOrder: CreateOrderType;
        setCreateOrder: React.Dispatch<React.SetStateAction<CreateOrderType>>;
    };

    const instructionsArray = Object.values(text.consentText).map((text) => {
        if (text.includes("ფიზიკური პირისთვის")) {
            const [main, sub] = text.split(":");

            return {
                type: "nested",
                main: main.trim(),
                sub: sub
                    .split(",")
                    .map(s => s.trim()),
            };
        }

        return {
            type: "normal",
            text,
        };
    });



    return (
        <>
            <Box sx={{
                //   display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                },
                gap: 3,
                mb: 4,
                width: "100%",
            }}>

                <Typography
                    className="font-helviteca"
                    sx={{
                        color: "#1C3553"
                    }}
                >
                    გთხოვთ დაეთანხმოთ წესებს და პირობებს
                </Typography>
                <Box
                    sx={{
                        maxHeight: 400,
                        overflowY: "auto",
                        pr: 1,
                    }}
                >
                    <List disablePadding>
                        {instructionsArray.map((item, idx) => (
                            <ListItem
                                key={idx}
                                alignItems="flex-start"
                                sx={{ px: 0 }}
                            >
                                <ListItemIcon sx={{ minWidth: 28, mt: "6px" }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#7D8DA6" }} />
                                </ListItemIcon>

                                <ListItemText
                                    primary={
                                        <>
                                            <Typography
                                                className="font-helviteca"
                                                sx={{
                                                    fontSize: { xs: 13, md: 14 },
                                                    color: "#27384E",
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                {item.type === "normal" ? item.text : item.main}
                                            </Typography>

                                            {/* 🔽 SUB LIST */}
                                            {item.type === "nested" && (
                                                <List disablePadding sx={{ mt: 1 }}>
                                                    {item.sub?.map((subText, subIdx) => (
                                                        <ListItem
                                                            key={subIdx}
                                                            sx={{ py: 0.5, px: 0 }}
                                                        >
                                                            <ListItemIcon sx={{ minWidth: 20 }}>
                                                                <FiberManualRecordIcon
                                                                    sx={{ fontSize: 6, color: "#9AA9BE" }}
                                                                />
                                                            </ListItemIcon>

                                                            <Typography
                                                                sx={{
                                                                    fontSize: { xs: 12.5, md: 13 },
                                                                    color: "#27384E",
                                                                }}
                                                            >
                                                                {subText}
                                                            </Typography>
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            )}
                                        </>
                                    }
                                />
                            </ListItem>
                        ))}
                    </List>

                </Box>

            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 2, maxWidth: 820, px: { xs: 1, md: 2 } }}>
                <Checkbox
                    sx={{
                        color: "#C2CEDB",
                        '&.Mui-checked': {
                            color: "#FF5440",
                        },
                    }}
                    checked={createOrder.isChecked || false}
                    onChange={(e) => setCreateOrder(prev => ({ ...prev, isChecked: e.target.checked }))}
                />
                <Typography className="font-helviteca" sx={{ fontSize: 14, color: "#27384E" }}>
                    ვეთანხმები პირობებს და პოლიტიკას
                </Typography>
            </Box>


        </>
    );
}

